import {BsChevronLeft, BsChevronRight} from "react-icons/bs";
import {useTranslation} from "react-i18next";

function Footer({ sim, setSim, goToQuestion, goNext }) {
    const { t, i18n } = useTranslation();
    const nextButtonText = () => {
        switch(sim.currentStep) {
            case 1:
                return <>{t('button.start')} <BsChevronRight /></>
            case 2:
            case 3:
            case 4:
                return <>{t('button.next')} <BsChevronRight /></>
            case 5:
                return <>{t('button.finish')} <BsChevronRight /></>
        }
    }
    const questionCountText = () => {
        if(sim.currentStep !== 2)
            return null
        if(sim.currentQuestions.length) {
            return t('sim.questionCount', { completed: sim.currentQuestion + 1, count: sim.currentQuestions.length})
        }
        return null
    }
    const nextButtonVisibility = () => {
        switch(sim.currentStep) {
            case 1:
                return sim.questions?.length > 0 && (sim.totalImages === false || sim.imagesLoaded >= sim.totalImages?.length)  ? 'visible' : 'hidden'
            case 3:
                return 'hidden'
        }
        return 'visible'
    }
    const backButtonVisibility = () => {
        if(sim.finished) {
            if(sim.currentQuestion > 0)
                return 'visible';

            return 'hidden'
        }
        switch(sim.currentStep) {
            case 2:
                return sim.currentQuestion > 0 ? 'visible' : 'hidden'
        }
        return 'hidden'
    }
    const goBack = () => {
        if(sim.finished) {
            if(sim.currentQuestion > 0)
                setSim({...sim,  currentQuestion: sim.currentQuestion - 1})
            else
                setSim({...sim, currentQuestion: 0, currentStep: 6})
            return
        }
        if(sim.currentQuestion > 0)
            goToQuestion(sim.currentQuestion - 1)
    }

    const footerVisibility = () => {
        switch(sim.currentStep) {
            case 3:
                return 'none'
        }
        return 'flex'
    }
    return (
        <div className="exam-sim-footer" style={{ display: footerVisibility() }}>
            <div className="exam-sim-footer-back" style={{visibility: backButtonVisibility()}}>
                <button type="button" onClick={goBack}>
                    <BsChevronLeft /> {t('button.previous')}
                </button>
            </div>
            <div className="exam-sim-footer-questions">
                {questionCountText()}
            </div>
            <div className="exam-sim-footer-next">
                <button type="button" onClick={goNext} style={{visibility: nextButtonVisibility()}}>{nextButtonText()}</button>
            </div>
        </div>
    );
}
export default Footer;
